function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0v75h43.75L75 56.25V0H12.5z",
  fill: "#EFEEEE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.25 56.25V75L75 56.25H56.25z",
  fill: "#ABABAB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 75h18.75V56.25L37.5 75z",
  fill: "#DEDEDD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 18.75v21.875h50V18.75H0z",
  fill: "#CB5641"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.912 23.019c.688 0 1.263.115 1.735.346.472.232.847.535 1.134.91.288.375.494.803.619 1.284.122.478.188.972.188 1.472 0 .688-.104 1.288-.31 1.8a3.23 3.23 0 01-.862 1.253 3.567 3.567 0 01-1.341.731 5.98 5.98 0 01-1.744.247H9.887v5.344h-2.7V23.02h4.725zm-.825 6.062c.538 0 .976-.166 1.304-.49.33-.326.496-.832.496-1.52 0-.674-.143-1.187-.43-1.537-.288-.347-.77-.525-1.445-.525H9.887v4.072h1.2zM23.35 23.016c.94 0 1.694.156 2.272.462.575.306 1.022.74 1.34 1.313.322.568.535 1.25.647 2.053.113.8.169 1.694.169 2.678 0 1.175-.069 2.197-.213 3.066-.143.865-.39 1.584-.74 2.146-.35.566-.819.982-1.406 1.257-.588.275-1.332.412-2.232.412h-4.262V23.016h4.425zm-.525 11.406c.475 0 .856-.081 1.144-.244.287-.162.515-.431.684-.806.172-.375.284-.869.337-1.485.057-.609.085-1.371.085-2.284 0-.762-.028-1.431-.075-2.01-.05-.574-.153-1.052-.31-1.434-.159-.38-.387-.668-.696-.859-.307-.194-.716-.294-1.229-.294h-1.14v9.416h1.2zM38.912 23.019v2.212h-4.78v3.15h4.5v2.213h-4.5v5.812h-2.7V23.02h7.48z",
  fill: "#fff"
});

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.fb4a8799.svg";
export { ForwardRef as ReactComponent };